const uniqueDriversReport = {
  table: {
    headers: {
      date: 'Datum',
      uniqueDrivers: 'Bestimmte Fahrer',
    },
    tableDetails: {
      headers: {
        date: 'Datum',
        uniqueDrivers: 'Bestimmte Fahrer',
        driver: 'Fahrer',
        trips: 'Fahrten',
      },
    },
  },
  actions: {
    export: 'Exportieren',
  },
};

export default uniqueDriversReport;
